import { useState, useEffect } from "react";
import RelatoriosService from "../../services/RelatoriosService";
import EcdTabela from "./EcdTabela";
import { IEcd } from "../../interfaces/IRelatorio";
import { IEmpresas } from "../../interfaces/IEmpresas";
import { IEsteira } from "../../interfaces/IRelatorioCliente";
import { limitarTexto } from "./Relatorio";

function RelatorioECD({ empresa, dataInicial, dataFinal, esteira }: { empresa: IEmpresas | undefined, dataInicial: Date | undefined, dataFinal: Date | undefined, esteira: IEsteira | undefined }) {
    
    const [carregado, setCarregado] = useState<boolean>(false);
    const [ecds, setEcds] = useState<IEcd[]>([]);
    const columns = [
        {
            name: 'Nome do Arquivo',
            selector:  (row: IEcd) => limitarTexto(row['nomeArquivo'], 28, 3),
            sortable: true,
        },
        {
            name: 'Data Inicial',
            selector:  (row: IEcd) => row['esteira'].periodoInicioString,
            sortable: true,
        },
        {
            name: 'Data Final',
            selector:  (row: IEcd) => row['esteira'].periodoFimString,
            sortable: true,
        },
        {
            name: 'Data de Upload',
            selector: (row: IEcd) => row['dataUploadString'],
            sortable: true
        },
        {
            name: 'Ações',
            cell: (row: IEcd) => <AcoesEcd verEcd={verEcd} ecd={row} />
        }
    ];

    useEffect(() => {
        async function preCarregar() {
            setCarregado(false);
            
            if (empresa) {
                await RelatoriosService.dadosEcd(empresa.id, x => setEcds((esteira?.id ?? 0) !== 0 ? x.filter(p => p.esteiraID === esteira?.id) : x));
                setCarregado(true);
            }
        }

        setTimeout(() => {
            preCarregar();
        }, 1000)

        // eslint-disable-next-line
    }, []);

    function AcoesEcd({ ecd, verEcd }: { ecd: IEcd, verEcd: (ecd: IEcd) => void }) {
        return <div data-tag="allowRowEvents">
            <i onClick={() => verEcd(ecd)} className="far fa-eye fs-1" style={{ color: '#5E6397', marginLeft: '20px', fontWeight: 'normal', cursor: 'pointer' }} />
        </div>
    }

    function verEcd(ecd: IEcd) {
        window.open(ecd.urlStorage);
    }

    return <>
        { 
            dataInicial && dataFinal ?
                carregado ? 
                    <EcdTabela colunas={columns} itens={ecds} />
                : <p className="mt-5">Carregando...</p>
            : <h2 className="mt-5">Preencha o campo Período e clique em buscar para carregar os dados</h2>
        }
    </>
};

export default RelatorioECD;